import { useNavigate, useParams } from 'react-router-dom';
import AddProductForm from '../components/products/AddProductModal';

export default function EditProduct() {
  const navigate = useNavigate();
  const { productId } = useParams<{ productId: string }>();

  if (!productId) {
    return <div>Product ID is missing.</div>;
  }

  return (
    <AddProductForm
      productId={productId}
      onCancel={() => navigate(`/products/${productId}`)}
      onCreated={(savedProductId) => navigate(`/products/${savedProductId}`)}
    />
  );
}
